
import { check, commonApi } from '@/common/index'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'

import { ValidateRequire, validataEmail } from '@/common/utils/validate.js'
export default {
name: 'verifyEmail',
components: { Group, XInput, XButton,Countdown },
data() {
return {
Email: '',
isReady: true,
verifCode:'',
showCountdown: true,
disabled: false,
start: false,
time: 60,
}
},
created() {
this.UUID = this.$Cookies.get('UUID');
const { email, emailValid } = this.$store.state.userInfo.userInfo
if(emailValid && email){

this.Email = email
}
},
methods: {
haveComToast(data,istype){
this.$vux.toast.show({ text: data, type: istype})
},
handleFinish(){
this.disabled = false;
this.start = false;
this.time = 60;
},
verifyEmail() {
if (!this.checkForm()) return
if (this.isReady) {
this.isReady = false;
commonApi.CONFIRM.confirmEmail({ UUID: this.UUID, email: this.Email, confirmCode: this.verifCode }).then(data=>{
this.isReady = true;
const { title, successTips } = this.$t('mine').emailAuth
this.$store.dispatch('getFirstInfo') 
this.$router.replace({path:'/My/AccountManat',query:{title, desc: successTips }})
}).catch(err=>{
this.isReady = true;
this.haveComToast(err,'cancel')
})
}
},
checkForm(){
if(!ValidateRequire(this.Email)) {
this.haveComToast(this.$t('mine').emailAuth.emailPlace,'cancel')
return
}
if(!validataEmail(this.Email)){
this.haveComToast(this.$t('mine').emailAuth.emailError,'cancel')
return
}
if(this.$store.state.linkList.isMailVerify === '1' && !ValidateRequire(this.verifCode)){
this.haveComToast(this.$t('mine').emailAuth.verifCodePlace,'cancel')
return
}
return true
},
handSendEmail(){
if (this.$store.state.userInfo.userInfo.emailValid) { // 邮箱已认证 请勿重复认证
this.haveComToast(this.$t('mine').emailAuth.authenticated,'cancel')
return
}
if(validataEmail(this.Email)){
this.disabled = true;
this.start = true;
commonApi.CONFIRM.email({UUID: this.UUID, email : this.Email,}).then(data=>{
this.haveComToast(this.$t('mine').emailAuth.codeSuccess,'success')
}).catch(err=>{
this.handleFinish()
this.haveComToast(err,'cancel')
});
}else {
this.haveComToast(this.$t('mine').emailAuth.emailError,'cancel')
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/AccountManat/emailAuth.vue